import {API} from "@/Composables/api";

const getHistory = async (params = {}) => {
    return API.get(route("ai.history"), params);
};

const generate = async (formData, params = {}) => {
    return API.post(route("ai.generate"), params, formData);
};

const clearHistory = async (params = {}) => {
    return API.post(route("ai.clear"), params);
};

export {getHistory, generate, clearHistory};
